import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-514d0329"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "no_data"
}


import { Archive } from '@/@types/typescript-axios'

type PropsType = {
  cameraDetail: Archive
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiVideoArchive',
  props: {
    cameraDetail: null
  },
  emits: ["loadedData", "loadedError"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (__props.cameraDetail.has_data)
    ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        ref: "video",
        muted: "",
        playsinline: "",
        src: __props.cameraDetail.data_url,
        onLoadeddata: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('loadedData', $event))),
        onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('loadedError')))
      }, null, 40, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('videos.no_data')), 1)
      ]))
}
}

})